// Which mark sits in the browser tab.
//
// Otto is a staff-side mascot and is deliberately absent from every supplier
// surface. The favicon was the one place that leaked: it is declared once in
// index.html and served to everyone, so a supplier signing in to the portal got
// an owl in their tab.
//
// The login page is SHARED — one route at `/` for staff and suppliers alike,
// and Login.js only discovers which you are after authenticating. So the tab
// cannot know who is looking at it until sign-in completes. That decides the
// default: the neutral Fusion roundel ships in index.html, and Otto is swapped
// in only once the app knows the session belongs to an internal user.
//
// Defaulting the other way — Otto in the HTML, swapped away for suppliers —
// would put an owl in a supplier's tab for the length of a page load and then
// snatch it back. Wrong by default, briefly, on the surface we were asked to
// keep him off.

const base = () => process.env.PUBLIC_URL || '';

// The ?v= suffixes match index.html. They are cache-busts, and they must stay
// in step with it: a swap to a URL the browser has never seen would otherwise
// refetch on every navigation.
export const FUSION_ICON = 'Fusion_Favicon_Dark.svg?v=4';
export const OTTO_ICON = 'otto-favicon.svg?v=6';

export const faviconHref = (file) => `${base()}/${file}`;

// Retarget the existing <link rel="icon"> rather than adding another. Two icon
// links let the browser choose, and the one it chooses is not always the last
// one — that is the picking race index.html's own comment warns about, and it
// is why the .ico link was removed in the first place.
export function setFavicon(file) {
  if (typeof document === 'undefined') return false;
  const link = document.querySelector('link[rel="icon"]');
  if (!link) return false;
  const href = faviconHref(file);
  if (link.getAttribute('href') === href) return true; // no-op; avoids a refetch
  link.setAttribute('href', href);
  return true;
}
